import React, { memo } from 'react';
import { Brain, MessageSquare, FileText, Calendar } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-[#FDFCF8] py-16 md:py-24 px-4" data-id="element-145">
      <div className="max-w-3xl mx-auto" data-id="element-146">
        {/* The Core Problem */}
        <div className="mb-20 text-center" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-6" data-id="element-148">
            El problema no es que "no te organizás"
          </h2>
          <p className="text-xl text-stone-600 mb-8" data-id="element-149">
            El problema es que el cuidado te come la cabeza. Porque el cuidado
            no es una tarea. Es un flujo constante de micro-decisiones:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left max-w-2xl mx-auto" data-id="element-150">
            {['¿Tomó la medicación?', '¿Era media pastilla o una?', '¿Ese turno era hoy o la semana que viene?', '¿Dónde está la credencial?', '¿Qué dijo el médico la última vez?', '¿Quién puede acompañar?'].map((q, i) => <div key={i} className="bg-white px-4 py-3 rounded-lg border border-stone-200 text-stone-700 shadow-sm text-sm md:text-base" data-id="element-151">
                "{q}"
              </div>)}
          </div>

          <p className="mt-8 text-lg font-medium text-stone-800" data-id="element-152">
            Y cuando hay estrés, la memoria no falla "un poquito". <br data-id="element-153" />
            <span className="text-red-800" data-id="element-154">Falla en el peor momento.</span>
          </p>
        </div>

        {/* Why Old Solutions Fail */}
        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-stone-100" data-id="element-155">
          <h3 className="text-2xl font-serif font-bold text-stone-900 mb-8 text-center" data-id="element-156">
            Por qué lo que probaste no funciona <br data-id="element-157" />
            <span className="text-base font-sans font-normal text-stone-500" data-id="element-158">
              (aunque seas responsable)
            </span>
          </h3>

          <div className="space-y-8" data-id="element-159">
            <div className="flex gap-4" data-id="element-160">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-stone-100 flex items-center justify-center text-stone-600" data-id="element-161">
                <MessageSquare className="w-5 h-5" data-id="element-162" />
              </div>
              <div data-id="element-163">
                <h4 className="font-bold text-stone-900" data-id="element-164">WhatsApp</h4>
                <p className="text-stone-600" data-id="element-165">
                  Lo importante queda enterrado. Nadie sabe cuál es el audio
                  correcto.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-166">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-stone-100 flex items-center justify-center text-stone-600" data-id="element-167">
                <FileText className="w-5 h-5" data-id="element-168" />
              </div>
              <div data-id="element-169">
                <h4 className="font-bold text-stone-900" data-id="element-170">Papeles sueltos</h4>
                <p className="text-stone-600" data-id="element-171">
                  Aparecen cuando ya es tarde o se pierden en el camino.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-172">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-stone-100 flex items-center justify-center text-stone-600" data-id="element-173">
                <Calendar className="w-5 h-5" data-id="element-174" />
              </div>
              <div data-id="element-175">
                <h4 className="font-bold text-stone-900" data-id="element-176">Una agenda común</h4>
                <p className="text-stone-600" data-id="element-177">
                  Sirve si sos una sola persona… pero el cuidado rara vez es de
                  una sola persona.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-178">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-stone-100 flex items-center justify-center text-stone-600" data-id="element-179">
                <Brain className="w-5 h-5" data-id="element-180" />
              </div>
              <div data-id="element-181">
                <h4 className="font-bold text-stone-900" data-id="element-182">"Yo me acuerdo"</h4>
                <p className="text-stone-600" data-id="element-183">
                  Funciona hasta que un día estás cansado/a, enojado/a,
                  apurado/a… y no.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-stone-100 text-center" data-id="element-184">
            <p className="text-xl font-serif italic text-stone-800" data-id="element-185">
              No es falta de amor. No es falta de voluntad. <br data-id="element-186" />
              <span className="not-italic font-bold" data-id="element-187">
                Es falta de un sistema compartible.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}